export const PrimaryColor = "#3AADA8";
export const AccentColor = "#318B84";
